var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ingIcon2",
    transform: "translate(-993 -317)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6193",
    "data-name": "\\uC0AC\\uAC01\\uD615 6193",
    width: 90,
    height: 90,
    rx: 45,
    transform: "translate(993 317)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ing2",
    transform: "translate(1014.999 338.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_59263",
    "data-name": "\\uADF8\\uB8F9 59263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_59262",
    "data-name": "\\uADF8\\uB8F9 59262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34144",
    "data-name": "\\uD328\\uC2A4 34144",
    d: "M211,422h8.086v8.086H211Z",
    transform: "translate(-192.042 -384.084)",
    fill: "#4c84d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34145",
    "data-name": "\\uD328\\uC2A4 34145",
    d: "M211,0h8.086V8.086H211Z",
    transform: "translate(-192.042)",
    fill: "#4c84d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34146",
    "data-name": "\\uD328\\uC2A4 34146",
    d: "M0,211H8.086v8.086H0Z",
    transform: "translate(0 -192.042)",
    fill: "#4c84d0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34147",
    "data-name": "\\uD328\\uC2A4 34147",
    d: "M422,211h8.086v8.086H422Z",
    transform: "translate(-384.084 -192.042)",
    fill: "#3363a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34148",
    "data-name": "\\uD328\\uC2A4 34148",
    d: "M0,0H8.086V8.086H0Z",
    transform: "translate(3.874 36.403) rotate(-45)",
    fill: "#4c84d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34149",
    "data-name": "\\uD328\\uC2A4 34149",
    d: "M0,0H8.086V8.086H0Z",
    transform: "translate(3.877 9.596) rotate(-45)",
    fill: "#4c84d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34150",
    "data-name": "\\uD328\\uC2A4 34150",
    d: "M0,0H8.086V8.086H0Z",
    transform: "translate(30.681 36.406) rotate(-45)",
    fill: "#3363a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34151",
    "data-name": "\\uD328\\uC2A4 34151",
    d: "M241,241h2.7v2.7H241Z",
    transform: "translate(-219.347 -219.347)",
    fill: "#d4e4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34152",
    "data-name": "\\uD328\\uC2A4 34152",
    d: "M171,241h2.7v2.7H171Z",
    transform: "translate(-155.636 -219.347)",
    fill: "#d4e4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34153",
    "data-name": "\\uD328\\uC2A4 34153",
    d: "M311,241h2.7v2.7H311Z",
    transform: "translate(-283.057 -219.347)",
    fill: "#8cc6ec"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34154",
    "data-name": "\\uD328\\uC2A4 34154",
    d: "M256.5,241h1.3v2.7h-1.3Z",
    transform: "translate(-233.454 -219.347)",
    fill: "#8cc6ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_59264",
    "data-name": "\\uADF8\\uB8F9 59264",
    transform: "translate(23.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34155",
    "data-name": "\\uD328\\uC2A4 34155",
    d: "M256.5,0h4V8.086h-4Z",
    transform: "translate(-256.5)",
    fill: "#3363a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34156",
    "data-name": "\\uD328\\uC2A4 34156",
    d: "M256.5,422h4v8.086h-4Z",
    transform: "translate(-256.5 -384.084)",
    fill: "#3363a1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngIcon2);
export default __webpack_public_path__ + "static/media/ingIcon2.381798c3541ff55552a3450b4cafd16d.svg";
export { ForwardRef as ReactComponent };